import "./Lubrication.module.css";
import Header from "@/reusable_sections/Header";
import Lubrificacao from "./sections/Lubrificacao";
import Lubrication from "./sections/Lubrication";
import Benefits from "./sections/Benefits";
import CallToAction from "./sections/CallToAction";
import IndustryFaq from "./sections/IndustryFaq";
import Footer from "@/reusable_sections/Footer";
export default function LubricationPage() {
  return <div>
      <Header />
      <Lubrificacao />
      <Lubrication />
      <Benefits />
      <IndustryFaq />
      <CallToAction />
      <Footer />
    </div>;
}